var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "q-color-svpanel",
      style: {
        backgroundColor: _vm.background,
      },
    },
    [
      _c("div", { staticClass: "q-color-svpanel__white" }),
      _vm._v(" "),
      _c("div", { staticClass: "q-color-svpanel__black" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "q-color-svpanel__cursor",
          style: {
            top: _vm.cursorTop + "px",
            left: _vm.cursorLeft + "px",
          },
        },
        [_c("div")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }